import React from 'react';
const SpeakerSVG = ({ color = 'black', className, ...props }) => {
  return (
    <svg
      width="22"
      height="18"
      viewBox="0 0 22 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={props.onClick}
    >
      <g id="Group 43623">
        <path
          id="Vector"
          d="M1.03411 7.99166C1.10636 6.80636 1.14248 6.21373 1.44961 5.6437C1.73022 5.12289 2.26712 4.61772 2.80403 4.3693C3.39169 4.09743 4.06526 4.09743 5.41241 4.09743C5.9145 4.09743 6.16555 4.09743 6.40873 4.05636C6.64913 4.01576 6.88355 3.94544 7.10661 3.84699C7.33224 3.74742 7.54182 3.60923 7.96101 3.33285L8.17567 3.1913C10.6691 1.54729 11.9158 0.72527 12.9624 1.08241C13.163 1.15088 13.3573 1.24973 13.5307 1.37164C14.4354 2.00745 14.5042 3.48676 14.6416 6.44538C14.6925 7.54091 14.7272 8.47848 14.7272 9.00002C14.7272 9.52156 14.6925 10.4591 14.6416 11.5547C14.5042 14.5133 14.4354 15.9926 13.5307 16.6283C13.3573 16.7503 13.163 16.8492 12.9624 16.9176C11.9158 17.2747 10.6691 16.4527 8.17567 14.8087L7.96101 14.6672C7.54182 14.3908 7.33224 14.2526 7.10661 14.153C6.88355 14.0546 6.64913 13.9843 6.40873 13.9437C6.16555 13.9026 5.9145 13.9026 5.41241 13.9026C4.06526 13.9026 3.39169 13.9026 2.80403 13.6307C2.26712 13.3823 1.73022 12.8771 1.44961 12.3563C1.14248 11.7863 1.10636 11.1936 1.03411 10.0084C1.01274 9.65775 1 9.31614 1 9.00002C1 8.6839 1.01274 8.34229 1.03411 7.99166Z"
          stroke={color}
          strokeWidth="1.5"
        />
        <path
          id="Vector_2"
          d="M19.1399 3.11719C19.1399 3.11719 20.6107 4.88212 20.6107 9.00029C20.6107 13.1185 19.1399 14.8834 19.1399 14.8834"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          id="Vector_3"
          d="M17.179 6.05859C17.179 6.05859 17.6692 6.94106 17.6692 9.00015C17.6692 11.0592 17.179 11.9417 17.179 11.9417"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </g>
    </svg>
  );
};

export default SpeakerSVG;
